module.exports = __webpack_public_path__ + "img/bg_作业试卷.818e493f.png";